<template>
  <div class="tournament-game-result">
    <span class="game-result">
      <span v-if="resultText" class="result-text">{{ resultText }}</span>
      <span v-else class="no-result-text">
        <span class="pawn has-text-white">♟</span>
        <span>⚔️</span>
        <span class="pawn has-text-black">♟</span>
      </span>
    </span>
  </div>
</template>

<script>
import {
  TOURNAMENT_FIDE_GAME_RESULT,
  TOURNAMENT_GAME_RESULT,
} from "vue-chess-shared/constants";

export default {
  name: "TournamentGameResult",
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    hasResults() {
      return (
        this.game.whiteResult !== undefined &&
        this.game.blackResult !== undefined &&
        this.game.whiteResult !== TOURNAMENT_GAME_RESULT.UNFINISHED &&
        this.game.blackResult !== TOURNAMENT_GAME_RESULT.UNFINISHED
      );
    },

    resultText() {
      if (!this.hasResults) return "";
      const w = this.getScoreFromResult(this.game.whiteResult);
      const b = this.getScoreFromResult(this.game.blackResult);
      if (w === "0" || w === "1") return `${w}-${b}`;
      return `${w || b}`;
    },
  },
  methods: {
    getScoreFromResult(result) {
      return TOURNAMENT_FIDE_GAME_RESULT[result] || "";
    },
  },
};
</script>

<style scoped>
.game-result {
  font-size: 1.2rem;
  font-family: monospace;
}

.result-text {
  font-size: 1.6rem;
  font-weight: bold;
}

.no-result-text {
  opacity: 0.85;
}
.pawn {
  font-size: 2rem;
}
</style>
